import { render, staticRenderFns } from "./StaffPaymentsView.vue?vue&type=template&id=a9b338a8&scoped=true"
import script from "./StaffPaymentsView.vue?vue&type=script&lang=js"
export * from "./StaffPaymentsView.vue?vue&type=script&lang=js"
import style0 from "./StaffPaymentsView.vue?vue&type=style&index=0&id=a9b338a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b338a8",
  null
  
)

export default component.exports